import FunnelLayout from "@components/quiz/FunnelLayout"
import Spinner from "@components/Spinner"

export default function LoadingPage() {
  return (
    <FunnelLayout>
      <div className="flex grow flex-col items-center justify-center">
        <Spinner />
      </div>
    </FunnelLayout>
  )
}
